module.exports = require("@wildboar/x500/src/lib/modules/SelectedAttributeTypes/UnboundedDirectoryString.ta");